import { useEffect, useState } from 'react';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type Reviews } from '../../shared/reviews';
import { fetchProductReviewsFromUrl } from '../services';
import { type ProductDetailContext } from '../types/types';
import { useProduct } from './useProduct';

type UseReviews = {
    reviews: Reviews | null;
    areReviewsInitiallyFetched: boolean;
};

export const useReviews = (): UseReviews => {
    const { productId } = useProduct();
    const { initialReviews } = useFragmentContext<ProductDetailContext>();

    const [reviews, setReviews] = useState<Reviews | null>(initialReviews);
    const [areReviewsInitiallyFetched, setAreReviewsInitiallyFetched] = useState(
        initialReviews !== null,
    );

    useEffect(() => {
        if (initialReviews !== null || reviews) {
            return;
        }

        (async () => {
            const response = await fetchProductReviewsFromUrl(productId);

            if (response && response.reviews) {
                setReviews(response);
            }

            setAreReviewsInitiallyFetched(true);
        })();
    }, [initialReviews, productId, reviews]);

    return { reviews, areReviewsInitiallyFetched };
};
